"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfLiffSetPriceModel = instanceOfLiffSetPriceModel;
exports.LiffSetPriceModelFromJSON = LiffSetPriceModelFromJSON;
exports.LiffSetPriceModelFromJSONTyped = LiffSetPriceModelFromJSONTyped;
exports.LiffSetPriceModelToJSON = LiffSetPriceModelToJSON;
exports.LiffSetPriceModelToJSONTyped = LiffSetPriceModelToJSONTyped;
/**
 * Check if a given object implements the LiffSetPriceModel interface.
 */
function instanceOfLiffSetPriceModel(value) {
    return true;
}
function LiffSetPriceModelFromJSON(json) {
    return LiffSetPriceModelFromJSONTyped(json, false);
}
function LiffSetPriceModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orgId': json['orgId'] == null ? undefined : json['orgId'],
        'frameNo': json['frameNo'] == null ? undefined : json['frameNo'],
        'price': json['price'] == null ? undefined : json['price'],
    };
}
function LiffSetPriceModelToJSON(json) {
    return LiffSetPriceModelToJSONTyped(json, false);
}
function LiffSetPriceModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orgId': value['orgId'],
        'frameNo': value['frameNo'],
        'price': value['price'],
    };
}
